export default "__VITE_ASSET__BOY1abvP__"